// extracted by mini-css-extract-plugin
module.exports = {"Grid":"display_Grid__2n48a","BuzzHover":"display_BuzzHover__UuNN4","hvr-buzz":"display_hvr-buzz__w3VB_"};